import { render } from "./AnswerList.vue?vue&type=template&id=5bed3c56"
import script from "./AnswerList.vue?vue&type=script&lang=js"
export * from "./AnswerList.vue?vue&type=script&lang=js"

import "./AnswerList.vue?vue&type=style&index=0&id=5bed3c56&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__